// import React from "react";
// import "./Add_to_card_btn.css";
// import Green_Outline_Btn from "../green_outline_btn/Green_Outline_Btn";
// import Brown_btn from "../brown_btn/Brown_btn";
// import { useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllCart, postCart } from "../../../../features/cart/cartSlice";
// import { variant_type } from "../../../../utils/common";

// function Add_to_card_btn({ id, product, item_id }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const isSignIn = useSelector((state) => state.auth.is_signin);
//   const isSignin = useSelector((state) => state.auth.is_signin);

//   const handleClick = () => {
//     navigate(`/product-cart?item_id=${item_id}`);
//   };

//   const cartItems = useSelector((state) => state.cart.cartData || []);

//   const cartQty = cartItems
//     .filter(
//       (item) =>
//         Number(item.product_id) === Number(product?.id) &&
//         Number(item.variant_id) === Number(firstVariant?.id),
//     )
//     .reduce((sum, item) => sum + Number(item.quantity || 0), 0);

//   const firstVariant = product?.Product_Variants?.[0];

//   const hasStock = (product) => {
//     return (
//       Number(product?.stock || 0) > 0 ||
//       product?.Product_Variants?.some((variant) => {
//         return (
//           Number(variant?.general_stock || 0) > 0 ||
//           variant?.Double_Variants?.some((doubleVar) => {
//             return (
//               Number(doubleVar?.stock || 0) > 0 ||
//               doubleVar?.Triple_Variants?.some(
//                 (tripleVar) => Number(tripleVar?.stock || 0) > 0,
//               )
//             );
//           })
//         );
//       })
//     );
//   };

//   const noStock = !hasStock(product);

//   const addToCart = async () => {
//     try {
//       // Prevent add to cart if no stock
//       if (noStock) return;

//       const data = {
//         item_id: item_id || firstVariant?.name || product?.ITEMNAME,
//         quantity: 1,
//         product_id: product?.id,
//         variant_type_id: product?.variant_type_id || variant_type.Single,
//         product_name: product?.name,
//         image: firstVariant?.image || product?.image,
//         tax_percentage: product?.tax_percentage,
//         variant_name: firstVariant?.name,
//         mrp: firstVariant?.mrp,
//         price: firstVariant?.price,
//         description: firstVariant?.description,
//         variant_id:
//           !product?.variant_type_id ||
//           Number(product?.variant_type_id) === Number(variant_type.Single)
//             ? firstVariant?.id
//             : null,

//         d_variant_id:
//           Number(product?.variant_type_id) === Number(variant_type.Double)
//             ? firstVariant?.Double_Variants?.[0]?.id
//             : null,

//         t_variant_id:
//           Number(product?.variant_type_id) === Number(variant_type.Triple)
//             ? firstVariant?.Double_Variants?.[0]?.Triple_Variants?.[0]?.id
//             : null,
//       };

//       const res = await dispatch(
//         postCart({
//           data,
//           isSignIn,
//         }),
//       );

//       if (res.meta?.requestStatus === "fulfilled") {
//         handleClick();

//         await dispatch(getAllCart(isSignin));

//         window.scrollTo({
//           top: 0,
//           behavior: "smooth",
//         });
//       }
//     } catch (error) {
//       console.log("Error:", error);
//     }
//   };

//   return (
//     <>
//       <section className="Add_to_card_btn">
//         <Green_Outline_Btn
//           btnText={noStock ? "Out of Stock" : "Add to cart"}
//           onClick={!noStock ? addToCart : undefined}
//           disabled={noStock}
//         />
//       </section>
//     </>
//   );
// }

// export default Add_to_card_btn;


import React from "react";
import "./Add_to_card_btn.css";
import Green_Outline_Btn from "../green_outline_btn/Green_Outline_Btn";
import { useNavigate } from "react-router-dom";

function Add_to_card_btn({ product }) {
  const navigate = useNavigate();

  const hasStock = (product) => {
    return (
      Number(product?.stock || 0) > 0 ||
      product?.Product_Variants?.some((variant) => {
        return (
          Number(variant?.general_stock || 0) > 0 ||
          variant?.Double_Variants?.some((doubleVar) => {
            return (
              Number(doubleVar?.stock || 0) > 0 ||
              doubleVar?.Triple_Variants?.some(
                (tripleVar) => Number(tripleVar?.stock || 0) > 0
              )
            );
          })
        );
      })
    );
  };

  const noStock = !hasStock(product);

  return (
    <section className="Add_to_card_btn">
      <Green_Outline_Btn
        btnText={noStock ? "Out of Stock" : "Add To Cart"}
        onClick={
          !noStock
            ? () => navigate(`/product-details/${product?.id}`)
            : undefined
        }
        disabled={noStock}
      />
    </section>
  );
}

export default Add_to_card_btn;